<template>
  <div class="winners-2021-stand">
    <img :src="src" :alt="alt" class="winners-2021-stand-img" />
  </div>
</template>

<script>
export default {
  name: "Winners2021Stand",
  props: {
    src: String,
    alt: String
  }
};
</script>

<style lang="scss">
.winners-2021-stand {
  display: block;
  background: url("~@/assets/img/winners/2021/winner-stand.png") 50% 50%
    no-repeat;
  position: relative;
  background-size: contain;
}

.winners-2021-stand-img {
  display: block;
  position: absolute;
  border: 2px solid #d9ca94;
}
</style>
